// components/SiteJsonLd.tsx
"use client";

import Script from "next/script";

export function SiteJsonLd() {
  const ldJson = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    url: "https://www.secretjoy.se/",
    hasPart: [
      { "@type": "SiteNavigationElement", name: "Våra Mysteryboxar", url: "https://www.secretjoy.se/shop" },
      { "@type": "SiteNavigationElement", name: "Om oss",             url: "https://www.secretjoy.se/om-oss" },
      { "@type": "SiteNavigationElement", name: "Abonnemang",         url: "https://www.secretjoy.se/kontakt" },
      { "@type": "SiteNavigationElement", name: "Artiklar",           url: "https://www.secretjoy.se/artiklar" },
    ],
  };

  return (
    <Script
      id="site-navigation-jsonld"
      type="application/ld+json"
      strategy="afterInteractive"
    >
      {JSON.stringify(ldJson)}
    </Script>
  );
}
